// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-a_container__32nxR"};